// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-pdf span {
  position: relative;
  bottom: -100px;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
}
.book-pdf img {
  position: relative;
  bottom: -128px;
  left: 12px;
}

.img-1 {
  background-image: url("https://assets.mydna.company/landing/vermas1.webp") !important;
  background-repeat: no-repeat;
  height: 20vh;
  background-position: top;
  border-radius: 20px;
}

.img-2 {
  background-image: url("https://assets.mydna.company/landing/vermas2.webp") !important;
  background-repeat: no-repeat;
  height: 20vh;
  background-position: top;
  border-radius: 20px;
}

.img-3 {
  background-image: url("https://assets.mydna.company/landing/vermas1.webp") !important;
  background-repeat: no-repeat;
  height: 20vh;
  background-position: top;
  border-radius: 20px;
}

.img-4 {
  background-image: url("https://assets.mydna.company/landing/vermas2.webp") !important;
  background-repeat: no-repeat;
  height: 20vh;
  background-position: top;
  border-radius: 20px;
}

.header-icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/Views/Service/Views/EntrenamientoYDesarrollo/EbooksYContenidos/EbookYContenidos.sass"],"names":[],"mappings":"AACQ;EACQ,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AAAhB;AAEQ;EACQ,kBAAA;EACA,cAAA;EACA,UAAA;AAAhB;;AAEA;EACQ,qFAAA;EACA,4BAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;AACR;;AAAA;EACQ,qFAAA;EACA,4BAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;AAGR;;AAFA;EACQ,qFAAA;EACA,4BAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;AAKR;;AAJA;EACQ,qFAAA;EACA,4BAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;AAOR;;AALA;EACQ,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAQR","sourcesContent":[".book-pdf\n        & span\n                position: relative\n                bottom: -100px\n                color: #fff\n                font-weight: bold\n                font-size: 12px\n\n        & img\n                position: relative\n                bottom: -128px\n                left: 12px\n\n.img-1\n        background-image: url(\"https://assets.mydna.company/landing/vermas1.webp\") !important\n        background-repeat: no-repeat\n        height: 20vh\n        background-position: top\n        border-radius: 20px\n.img-2\n        background-image: url(\"https://assets.mydna.company/landing/vermas2.webp\") !important\n        background-repeat: no-repeat\n        height: 20vh\n        background-position: top\n        border-radius: 20px\n.img-3\n        background-image: url(\"https://assets.mydna.company/landing/vermas1.webp\") !important\n        background-repeat: no-repeat\n        height: 20vh\n        background-position: top\n        border-radius: 20px\n.img-4\n        background-image: url(\"https://assets.mydna.company/landing/vermas2.webp\") !important\n        background-repeat: no-repeat\n        height: 20vh\n        background-position: top\n        border-radius: 20px\n\n.header-icon\n        background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%)\n        width: 50px\n        height: 50px\n        border-radius: 50rem\n        margin: 0 10px\n        display: flex\n        align-items: center\n        justify-content: center"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
